/**
 * Severity Cell Renderer
 *
 * Renders the vulnerability severity badge with color coding.
 * Displays severity level (Critical, High, Medium, Low, Info, Exposure).
 */

import { RiskTag } from '@praetorian-chariot/ui';
import React from 'react';

import type { RiskWithVulnerability } from '@/hooks/useRisks';
import { getRiskTagSeverity } from '@/sections/vulnerabilities/components/VulnerabilityDrawer';

interface SeverityCellProps {
  risk: RiskWithVulnerability;
}

/**
 * Memoized cell renderer for vulnerability severity column
 *
 * Extracts severity from risk status and displays as color-coded badge.
 * Severity is encoded in the status string (second character).
 *
 * @param risk - The vulnerability/risk to render severity for
 * @returns RiskTag component with appropriate severity styling
 */
export const SeverityCell: React.FC<SeverityCellProps> = React.memo(
  ({ risk }) => {
    const severity = getRiskTagSeverity(risk.status);

    return <RiskTag severity={severity} size="xs" />;
  }
);

SeverityCell.displayName = 'SeverityCell';
